<lib-machine-chart
  [workCenterId]="workCenterId$ | async"
  [isFullViewMode]="true"
  [isAutoUpdate]="true"
  [showDatetimeFilter]="true"
  [chartMode]="chartMode"
></lib-machine-chart>
